<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import VideoHistoryList from './VideoHistoryList'
import VideoHistoryPlayer from './VideoHistoryPlayer'
import McButtonBack from '@/components/McButtonBack'
// import WidgetDownload from './WidgetDownload'
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'

export default {
  name: 'VideoHistory',
  page: {
    title: 'Riwayat Video',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    McButtonBack,
    VideoHistoryPlayer,
    VideoHistoryList,
    // WidgetDownload,
  },
  mixins: [Helper, MixPanel],
  computed: {
    ...mapGetters('vehicle', ['vehicleDetail']),
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    isVideoDemo() {
      const dataDemoVideoHistory = this.getFeatureFlagValue('vsms2_trackvision2_playback_demo_id')
      return Object.keys(dataDemoVideoHistory).includes(this.$route.params.vehicleId.toString())
    },
  },
  watch: {
    'vehicleDetail.licensePlate': {
      handler() {
        if (this.vehicleDetail.licensePlate && this.$route.params.entryPoint) {
          this.track('Visit Video History Page', {
            license_plate: this.vehicleDetail.licensePlate,
            entry_point: this.$route.params.entryPoint,
          })
        }
      },
      deep: true,
    },
  },
  mounted() {
    // TODO: is this needed ?
    // this.$store.commit('vehicle/clearPeriod')
    // ENDTODO
    this.$store.commit('vehicle/clearVideoStates')
    this.$store.commit('vehicle/clearPickVideo')
    this.$store.commit('vehicle/setVideoStatusDetail', 'noVideo')
    this.$store.commit('vehicle/setSource', '')
    this.$store.commit('vehicle/clearStatusText')
    this.$store.commit('vehicle/setPlaybackUidActive', null)
  },

  methods: {
    goToVideoHistory() {
      this.track('Open Video Download History')
      if (this.isVideoDemo) {
        this.$router.push({
          name: 'Video History 3 Download',
          query: {
            isDemo: true,
          },
        })
        return
      }
      this.$router.push({ name: 'Video History 3 Download' })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-videohistory-page-top-container">
      <h3 class="mc-general__label">{{ $t('videoHistory.pageTitle') }}</h3>
      <div class="mc-videohistory__nav-wrapper">
        <McButtonBack :href="`/trackvideo-2`" />
        <b-button variant="outline-primary" @click="goToVideoHistory">
          <i class="mc-fa icon-outline_file-text"></i>{{ $t('trackVideo.historyVideoDownload') }}
        </b-button>
      </div>
    </div>
    <b-container fluid class="mc-videohistory mc-videohistory-3">
      <div class="mc-videhistory-row--container">
        <VideoHistoryPlayer />
        <VideoHistoryList />
        <!-- <WidgetDownload /> -->
      </div>
    </b-container>
  </Layout>
</template>
